export const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
export const PUBLIC_URL = process.env.PUBLIC_URL;
